import Booking from './Booking'

export default Booking
